import { eventQBus } from "../../types/EventQBus";
import { AvContent } from "./AvContent";
import tracking from "../../tracking/Tracking";
import { toggles } from "../../private/utils/Toggles";

const DUNDEE_ENTRY_RULE_PAGE_TYPES = ["Produktliste", "Suchergebnisseite", "Themenseite"];
const BACKEND_ENTRY_RULE_PAGE_TYPES = ["Einstiegsseite", "Service", "Brandhub", "Brandindex"];

let singleton: EntryRule | undefined;

export class EntryRule {
  /*               */
  private constructor(readonly rule: string) {}

  /*                  */

  static instance() {
    if (!singleton) {
      const rule = EntryRule.entryRule;
      if (rule) {
        singleton = new EntryRule(rule);
      }
    }
    return singleton;
  }

  /*               */

  static register(): void {
    const entryRule = EntryRule.instance();
    if (entryRule) {
      eventQBus.on("ftfind.history.merge", () => entryRule.updateHistoryState());
      eventQBus.on("ftfind.history.push", () => entryRule.updateHistoryState());
      window.addEventListener("pageshow", () => {
        if (EntryRule.shouldTrackPageShow()) {
          entryRule.trackSanEntrySelectionRule();
        }
      });
    }
  }

  /*                       */

  static get entryRule() {
    return EntryRule.historyRule || AvContent.pageRule();
  }

  static shouldTrackPageShow() {
    const pageType = AvContent.pageType();
    if (pageType && BACKEND_ENTRY_RULE_PAGE_TYPES.includes(pageType)) {
      return false;
    }
    return !(
      pageType &&
      DUNDEE_ENTRY_RULE_PAGE_TYPES.includes(pageType) &&
      toggles.isActive("REPTILE_1303_NAVIGATION_HISTORY")
    );
  }

  private static get historyRule(): string | undefined {
    return window.history.state?.entryRule;
  }

  private static set historyRule(entryRule: string | undefined) {
    if (entryRule) {
      window.history.replaceState(
        {
          ...window.history.state,
          entryRule,
        },
        "",
      );
    }
  }

  updateHistoryState(): void {
    EntryRule.historyRule = this.rule;
  }

  trackSanEntrySelectionRule() {
    tracking.addToPageImpression({
      "wk.san_EntrySelectionRule": this.rule,
    });
  }
}
